(function () {
  'use strict';

  angular.module('app').component('exchangeRateList', exchangeRateList());

  function exchangeRateList() {
    return {
      bindings: {
        currency: '=',
        companyBaseCurrency: '<',
        currencyExchangeRates: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowExchangeRate: '&',
        onExchangeRateDeleted: '&',
      },
      controller: ExchangeRateListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/exchange-rates/exchange-rate-list/exchange-rate-list.component.html',
    };
  }

  ExchangeRateListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'moment',
    'ExchangeRateService',
  ];

  function ExchangeRateListCtrl(config, UtilService, AbilityService, moment, ExchangeRateService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canUpdate: AbilityService.can('update_exchangerate_accountadmin'),
      canDestroy: AbilityService.can('destroy_exchangerate_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.filterCriteria = ExchangeRateService.getFilterCriteria();

    // private properties
    let today = moment().startOf('day');

    vm.$onInit = function () {
      vm.showAllExchangeRates = true;
    };

    // public methods
    // -----------------------
    vm.refresh = function () {
      vm.filterCriteria = ExchangeRateService.getFilterCriteria();
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      vm.fetchResult();
    };

    vm.fetchResult = function () {
      vm.filterCriteria.currency_id = vm.currency.id;
      vm.filterCriteria.skip_check_role = true;

      vm.loadingItems = true;
      ExchangeRateService.getExchangeRates(vm.filterCriteria).then(function (data) {
        vm.currencyExchangeRates = data.items;
        vm.meta = data.meta;

        vm.currencyExchangeRates.map((x) => {
          x.isCurrentRate = today.isBetween(x.from, x.to, undefined, '[]') ? true : false;
        });

        // console.log(vm.currencyExchangeRates);

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    };

    vm.editExchangeRate = function (item) {
      if (item.status === 'inactive' || vm.currency.enable_automatic_exchange_rate) return false;

      let exchangeRate = angular.copy(item);

      vm.onShowExchangeRate({ item: exchangeRate });
    };

    vm.deleteExchangeRate = function (item, index) {
      if (!vm.permissions.canDestroy || item.isCurrentRate || !item.isLastExchangeRate) {
        return;
      }

      const deleteCallback = () => {
        vm.currency.exchange_rates.splice(index, 1);

        vm.onExchangeRateDeleted();
      };

      ExchangeRateService.deleteExchangeRate(item, deleteCallback);
    };
  }
})();
